import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Feature";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import About from "./components/About";
import Contact from "./components/Contact";

// Auth Pages
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { OTPPage } from "./pages/OTPPage";
import { CompanyProfilePage } from "./pages/CompanyProfilePage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";

// Main Pages
import { DashboardPage } from "./pages/DashboardPage";
import { TransactionsPage } from "./pages/TransactionsPage";
import { AddTransactionPage } from "./pages/TransactionAddPage";
import { EditTransactionPage } from "./pages/TransactionEditPage";
import { TransactionViewPage } from "./pages/TransactionViewPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { CategoryAddPage } from "./pages/CategoryAddPage";
import { CategoryViewPage } from "./pages/CategoryViewPage";
import { AnalyticsReportsPage } from "./pages/AnalyticsReportsPage";
import { ChatInterfacePage } from "./pages/ChatInterfacePage";
import { ProfilePage } from "./pages/ProfilePage";
import { SettingsPage } from "./pages/SettingsPage";
import { StocksPage } from "./pages/StocksPage";
import { StockViewPage } from "./pages/StockViewPage";
import { StockEditPage } from "./pages/StockEditPage";

function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Pricing />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
        <Routes>
          {/* Landing Pages */}
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-otp" element={<OTPPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/company-profile" element={<CompanyProfilePage />} />

          {/* Main Routes */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/transactions/add" element={<AddTransactionPage />} />
          <Route path="/transactions/:id/edit" element={<EditTransactionPage />} />
          <Route path="/transactions/:id/view" element={<TransactionViewPage />} />

          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/categories/add" element={<CategoryAddPage />} />
          <Route path="/categories/:id/edit" element={<CategoryAddPage />} />
          <Route path="/categories/:id/view" element={<CategoryViewPage />} />

          <Route path="/analytics-reports" element={<AnalyticsReportsPage />} />
          <Route path="/analytics" element={<AnalyticsReportsPage />} />
          <Route path="/reports" element={<AnalyticsReportsPage />} />
          
          {/* Stock routes - specific routes BEFORE general route */}
          <Route path="/stocks/:id/view" element={<StockViewPage />} />
          <Route path="/stocks/:id/edit" element={<StockEditPage />} />
          <Route path="/stocks" element={<StocksPage />} />
          <Route path="/chat-interface" element={<ChatInterfacePage />} />

          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
